import React, { useState } from 'react'
import BioData from './Basic.profile.index'
import AdditionalInfo from './Detailed.profile'

const Profile = ({profile, setProfile}:any) => {
    const [tab, setTab] = useState('basics')
return (
    <>
        <div className="header bg-white px-4 pt-2 rounded shadow-sm">
            <div className="header-body pt-0">
                <AccountNav tab={tab} setTab={setTab} />
            </div>
        </div>
        <div className="row justify-content-center">
            <div className='col-12'>
                {tab === 'basics' && <BioData profile={profile} setProfile={setProfile} />}
                {tab === 'detailed_profile' && <AdditionalInfo profile={profile} setProfile={setProfile} />}
            </div>
        </div>
    </>
)
}

export default Profile


const AccountNav = ({tab, setTab}:any) => {
    return(
        <div className="row align-items-end ">
            <div className = 'col'>
                <ul className="nav nav-tabs header-tabs">
                <li className="nav-item">
                        <div className={`nav-link pointer pt-2 pb-2 px-1 cursor-pointer ${tab === 'basics' && 'active'}`} onClick = {() => setTab('basics')}>Basics</div>
                    </li>
                    <li className="nav-item">
                        <div className={`nav-link pointer pt-2 pb-2 px-1 cursor-pointer ${tab === 'detailed_profile' && 'active'}`} onClick = {() => setTab('detailed_profile')}>Additional Info</div>
                    </li>
                </ul>

            </div>
        </div>
    )
}